import cn from 'classnames'
import {FC, PropsWithChildren} from 'react'

import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextFontWeight, TextVariant} from '../common/content/Text'

type GuideSelectionContentBoxProps = {
  title: string
  textAlign?: 'left' | 'center'
  orientation?: 'vertical' | 'horizontal'
  contentMaxWidth?: string
}

export const GuideSelectionContentBox: FC<PropsWithChildren<GuideSelectionContentBoxProps>> = ({
  title,
  textAlign = 'left',
  orientation = 'horizontal',
  contentMaxWidth = '60%',
  children,
}) => (
  <>
    <div className={cn('box', orientation, textAlign === 'center' && 'centered')}>
      <Text variant={TextVariant.h5} element="h3" fontWeight={TextFontWeight.bold}>
        {title}
      </Text>
      <div className="content">{children}</div>
    </div>

    <style jsx>{`
      .box {
        background-color: ${theme.palette.background.butter};
        border-radius: 12px;
        padding: ${theme.spacing[4]} ${theme.spacing[5]};
      }
      .box + .box {
        margin-top: ${theme.spacing[4]};
      }
      .horizontal {
        display: flex;
        justify-content: space-between;
      }
      .horizontal .content {
        flex: 0 0 ${contentMaxWidth};
        margin-left: ${theme.spacing[7]};
      }
      .vertical .content {
        margin-top: ${theme.spacing[5]};
      }
      .centered {
        text-align: center;
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .horizontal .content {
          margin-left: ${theme.spacing[6]};
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .box {
          border-radius: 8px;
          padding: ${theme.spacing[3]} ${theme.spacing[3]} ${theme.spacing[4]};
          text-align: left;
        }
        .horizontal {
          display: block;
        }
        .horizontal .content {
          flex: 1;
          margin-left: 0;
          margin-top: ${theme.spacing[4]};
        }
        .vertical .content {
          margin-top: ${theme.spacing[4]};
        }
      }
    `}</style>
  </>
)
